// import libraries
import {
  updateUserProfileDoc,
  saveBusinessAtAGlanceDoc,
  saveBusinessConfig,
} from "./api";

const SLICE_NAME = "firstTimeSetup";

export const createFirstTimeSetupSlice = (set, get) => ({
  [SLICE_NAME]: {
    isSaving: false,
    error: null,

    updateUserProfile: async ({ uid, values }) => {
      if (!uid) throw new Error("updateUserProfile requires uid");
      set((state) => ({
        features: {
          ...(state.features || {}),
          [SLICE_NAME]: {
            ...(state.features?.[SLICE_NAME] || {}),
            isSaving: true,
            error: null,
          },
        },
      }));
      try {
        const payload = await updateUserProfileDoc(uid, values);

        // Refresh userRecord in common slice and keep subscription alive
        const common = get().common;
        if (common?.userRecord?.selectUserRecordById) {
          await common.userRecord.selectUserRecordById({ id: uid, subscribe: true });
        }
        return payload;
      } catch (error) {
        set((state) => ({
          features: {
            ...(state.features || {}),
            [SLICE_NAME]: { ...(state.features?.[SLICE_NAME] || {}), error },
          },
        }));
        throw error;
      } finally {
        set((state) => ({
          features: {
            ...(state.features || {}),
            [SLICE_NAME]: {
              ...(state.features?.[SLICE_NAME] || {}),
              isSaving: false,
            },
          },
        }));
      }
    },

    saveBusinessAtAGlance: async ({ uid, values }) => {
      if (!uid) throw new Error("saveBusinessAtAGlance requires uid");
      set((state) => ({
        features: {
          ...(state.features || {}),
          [SLICE_NAME]: {
            ...(state.features?.[SLICE_NAME] || {}),
            isSaving: true,
            error: null,
          },
        },
      }));
      try {
        const payload = await saveBusinessAtAGlanceDoc(uid, values);
        return payload;
      } catch (error) {
        set((state) => ({
          features: {
            ...(state.features || {}),
            [SLICE_NAME]: { ...(state.features?.[SLICE_NAME] || {}), error },
          },
        }));
        throw error;
      } finally {
        set((state) => ({
          features: {
            ...(state.features || {}),
            [SLICE_NAME]: {
              ...(state.features?.[SLICE_NAME] || {}),
              isSaving: false,
            },
          },
        }));
      }
    },

    saveBusinessConfig: async ({ uid, values }) => {
      if (!uid) throw new Error("saveBusinessConfig requires uid");
      set((state) => ({
        features: {
          ...(state.features || {}),
          [SLICE_NAME]: {
            ...(state.features?.[SLICE_NAME] || {}),
            isSaving: true,
            error: null,
          },
        },
      }));
      try {
        const ok = await saveBusinessConfig(uid, values);
        return ok;
      } catch (error) {
        set((state) => ({
          features: {
            ...(state.features || {}),
            [SLICE_NAME]: { ...(state.features?.[SLICE_NAME] || {}), error },
          },
        }));
        throw error;
      } finally {
        set((state) => ({
          features: {
            ...(state.features || {}),
            [SLICE_NAME]: {
              ...(state.features?.[SLICE_NAME] || {}),
              isSaving: false,
            },
          },
        }));
      }
    },
  },
});

export const selectFirstTimeSetupSlice = (state) =>
  state.features?.[SLICE_NAME] || {};
